import { Pipe, PipeTransform } from '@angular/core';

@Pipe ({
    name: 'groupBy'
})

export class GroupByPipe implements PipeTransform {
    transform(collection, property: string) {
        if (!collection) {
            return 0;
        }
        
        return collection.Influencer.filter (
            data => data.influencer_type === property
        ).length;
    }
}
